/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

const fetchWorkers = async (vendorCode: string) => {
    const workers = await apiInputService.get("/Worker/vendorNumber/" + vendorCode)
    const { data } = workers;

    return data;
}


export const useWorkersByVendorCode = (vendorCode: string, options?: any) => {
    return useQuery<any[]>(["workers", vendorCode], () => fetchWorkers(vendorCode), {
        staleTime: 1 * 60 * 1000, // 1 minute
        ...options
    });
}